// extracted by mini-css-extract-plugin
module.exports = {"o1wz5y2i":"o1wz5y2i","w164f7kz":"w164f7kz","twur3px":"twur3px"};